import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'web-ui-components/lib/layout/grids';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { StatusTag } from 'web-ui-components/lib/typography/tags';
import { verificationPropTypes } from '../../states/payments/propTypes';
import withContent from '../../containers/withContent';
import authoriseContent, { contentPropTypes } from './Authorise.content';
import { REVIEWED } from '../../constants/Constants';

export const SoftTokenStatusTable = ({ toAuthorise, fileUploadPaymentByOthers, byYouTabActive, content }) => {
	const {
		status,
		authorisationRequired,
		mobileBankingApp,
		twoStepReviewDetails,
		howtoAuthoriseGroupApprovals,
		howToAuthoriseBacsDetailsForOther,
		howToAuthoriseBacsDetailsForOtherPlural,
		by,
		paymentStatus,
		hasGroupApprovalsEnabled,
	} = content;
	if (toAuthorise.status !== REVIEWED && byYouTabActive) {
		return null;
	}

	const getAuthoriseContentSoftTokenView = () => {
		if (fileUploadPaymentByOthers && !byYouTabActive) {
			{
				return hasGroupApprovalsEnabled ? (
					<StandardBody>
						<p>{howtoAuthoriseGroupApprovals}</p>
					</StandardBody>
				) : (
					<div>
						<p>
							{`${by} ${
								fileUploadPaymentByOthers.approvers &&
								fileUploadPaymentByOthers.approvers.map((item) => item.approver).join(' and ')
							}`}
						</p>
						<p>
							{fileUploadPaymentByOthers.approvers && fileUploadPaymentByOthers.approvers.length > 1
								? howToAuthoriseBacsDetailsForOtherPlural
								: howToAuthoriseBacsDetailsForOther}
						</p>
					</div>
				);
			}
		}
		return (
			<div>
				<p>{mobileBankingApp}</p>
				<p>{twoStepReviewDetails}</p>
			</div>
		);
	};

	const statusData = [
		{ headerText: status, cellText: <StatusTag.WarningMinor isFlush>Awaiting Authorisation</StatusTag.WarningMinor> },
		{ headerText: authorisationRequired, cellText: getAuthoriseContentSoftTokenView() },
	];

	return (
		<Grid.TwoThirds>
			<SectionHeading>{paymentStatus}</SectionHeading>
			<VerticalReviewTable data={statusData} />
		</Grid.TwoThirds>
	);
};

SoftTokenStatusTable.propTypes = {
	toAuthorise: PropTypes.func.isRequired,
	fileUploadPaymentByOthers: PropTypes.shape(verificationPropTypes).isRequired,
	content: PropTypes.shape(contentPropTypes),
	byYouTabActive: PropTypes.bool.isRequired,
};

const contentWrapper = withContent({ content: authoriseContent });
export default contentWrapper(SoftTokenStatusTable);
